import { ui } from "@patient-watch/ui";
import { useProfileCopy } from "@/features/i18n/profileCopy";

import { useTheme } from "../../../hooks/useTheme";

const DarkModeSwitch = () => {
    const { theme, setTheme } = useTheme();
    const copy = useProfileCopy();
    const isDark = theme === "dark";

    return (
        <div className="flex justify-between items-center gap-4 my-4 w-full">
            <div className="min-w-0">
                <ui.Label htmlFor="profile-dark-mode" className="text-lg">
                    {copy.darkMode}
                </ui.Label>
                <p className="text-muted-foreground text-sm">{copy.darkModeDescription}</p>
            </div>
            <ui.Switch
                id="profile-dark-mode"
                color="indigo"
                checked={isDark}
                data-testid="dark-mode-switch"
                aria-label={isDark ? copy.switchToLightMode : copy.switchToDarkMode}
                onCheckedChange={() => setTheme(isDark ? "light" : "dark")}
            />
        </div>
    );
};

export default DarkModeSwitch;
